import React, { useEffect, useState } from 'react';
import { folderManagementServices } from '../../APIServices/folderManagementServices';
import { useToast } from '../../hooks/useToast';

function UpdateFolder({
  folderData,
  setConfirm,
  confirm,
  setModalOpen,
  getFolderManagementData
}) {
  const toast = useToast();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const updateFolderManagementData = async (e) => {
    setButtonLoader(true);
    try {
      let userData = {};
      userData.uniqueId = folderData?.uniqueId;
      userData.code = code;
      userData.name = name;
      userData.description = description;
      let data = await folderManagementServices.updateFolderManagementData(
        userData
      );
      if (data?.statusCode === 200) {
        toast(data?.customMessage || 'Folder updated successfully.', 'ok');
        getFolderManagementData();
        setConfirm(false);
        setModalOpen("");
        setName("");
      } else {
        toast(data?.customMessage || 'Unable to update folder.', 'warn');
      }
    } catch (error) {
      toast('Unable to update folder. Please try again.', 'warn');
    } finally {
      setButtonLoader(false);
    }
  }

  useEffect(() => {
    setCode(folderData?.code || "");
    setName(folderData?.name);
    setDescription(folderData?.description || "");
  }, [folderData]);

  return (
    <div
      className="modal-backdrop"
      onClick={() =>
        setModalOpen("")
      }
    >
      <div
        className="modal"
        style={{ maxWidth: 480 }}
        onClick={(e) =>
          e.stopPropagation()
        }
      >
        <div className="modal-head">
          <div>
            <div className="modal-title">
              Edit Folder
            </div>

            <div className="xs muted">
              Update the folder details
            </div>
          </div>

          <button
            className="icon-btn"
            onClick={() =>
              setModalOpen("")
            }
          >
            <i className="ti ti-x" />
          </button>
        </div>

        <div className="modal-body">
          <div className="field">
            <label className="field-label">
              Folder Code
              <span className="req">
                *
              </span>
            </label>
            <input
              className="inp"
              autoFocus
              disabled={buttonLoader || confirm}
              placeholder="e.g., CL-01"
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
          </div>

          <div className="field">
            <label className="field-label">
              Folder Name
              <span className="req">
                *
              </span>
            </label>
            <input
              className="inp"
              autoFocus
              disabled={buttonLoader || confirm}
              placeholder="e.g., Clinical Lead"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="field">
            <label className="field-label">
              Description
            </label>
            <textarea
              className="ta"
              disabled={buttonLoader || confirm}
              placeholder="Brief description of this folder"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={3}
            />
          </div>
        </div>
        <div className="modal-foot">
          {confirm ?
            <>
              <button
                className="btn btn-ghost"
                onClick={() => setConfirm(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary d-flex align-items-center justify-content-center gap-2"
                onClick={updateFolderManagementData}
                disabled={buttonLoader || !code || !name}
              >
                {buttonLoader ? (
                  <>
                    <div className="buttonLoader"></div>
                    <span>Updating...</span>
                  </>
                ) : (
                  <>
                    <i className="ti ti-check"></i>
                    <span>Yes, Update It!</span>
                  </>
                )}
              </button>
            </>
            :
            <>
              <button
                className="btn btn-ghost"
                onClick={() => setModalOpen("")}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary d-flex align-items-center justify-content-center gap-2"
                onClick={() => setConfirm(true)}
                disabled={!code || !name}
              >
                Update Folder
              </button>
            </>
          }
        </div>
      </div>
    </div>
  );
}

export default UpdateFolder;
